import { render, staticRenderFns } from "./FeedbackReplyPopup.vue?vue&type=template&id=160ee322&scoped=true&"
import script from "./FeedbackReplyPopup.vue?vue&type=script&lang=ts&"
export * from "./FeedbackReplyPopup.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackReplyPopup.vue?vue&type=style&index=0&id=160ee322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160ee322",
  null
  
)

export default component.exports